module.exports = __webpack_public_path__ + "static/media/Project_IoT_infra.bc538c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Static/Project_IoT_infra.png
// module id = 37
// module chunks = 1